import Api from "../Api";
import {getByAlias} from '../selectors/common';

export const GALLERIES_LOADED = '@app/galleries/loaded';
export const GALLERIES_LOADING = '@app/galleries/loading';
export const GALLERIES_ERROR = '@app/galleries/error';
export const GALLERIES_NOT_FOUND = '@app/galleries/notFound';

const initialState = {
    items: {},
    currentPage: null,
    pageCount: null,
    perPage: null,
    totalCount: null,
    language: null,
    error: false,
    notFound: false,
    loading: false,
};

export const setErrorFlag = (value) => {
    return {
        type: GALLERIES_ERROR,
        value,
    }
};

export const setNotFoundFlag = (value) => {
    return {
        type: GALLERIES_NOT_FOUND,
        value,
    }
};

export const setLoadingFlag = (value) => {
    return {
        type: GALLERIES_LOADING,
        value,
    }
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GALLERIES_LOADED: {
            const items = {};

            for (let i = 0; i < action.items.length; i++) {
                items[action.items[i].id] = action.items[i];
            }

            return Object.assign({}, state, {
                items,
                language: action.language,
                currentPage: action.currentPage,
                pageCount: action.pageCount,
                perPage: action.perPage,
                totalCount: action.totalCount,
            });
        }
        case GALLERIES_ERROR: {
            return Object.assign({}, state, {error: action.value});
        }
        case GALLERIES_NOT_FOUND: {
            return Object.assign({}, state, {notFound: action.value});
        }
        case GALLERIES_LOADING: {
            return Object.assign({}, state, {loading: action.value});
        }
        default:
            return state;
    }
}

export const fetchGalleries = (params) => (dispatch, getState) => {
    params.page = params.page ? params.page : 1;

    if (isNaN(params.page)) {
        dispatch(setNotFoundFlag(true));
        return;
    }

    dispatch(setErrorFlag(false));
    dispatch(setNotFoundFlag(false));
    dispatch(setLoadingFlag(true));

    const state = getState();

    params.page = params.page ? parseInt(params.page, 10) : 1;
    params['_lang'] = state.app.language;

    return Api.galleries(params).then((data) => {
        data.type = GALLERIES_LOADED;
        data.language = state.app.language;
        dispatch(data);

        dispatch(setLoadingFlag(false));
    }).catch(() => {
        dispatch(setErrorFlag(true));
        dispatch(setLoadingFlag(false));
    });
};

export const fetchGallery = (alias) => (dispatch, getState) => {
    dispatch(setErrorFlag(false));
    dispatch(setNotFoundFlag(false));

    const state = getState();

    if (getByAlias(state.galleries.items, alias) !== null) {
        dispatch(setLoadingFlag(false));
        return;
    }

    dispatch(setLoadingFlag(true));

    return Api.galleries({'_lang': state.app.language, alias}).then((data) => {

        if (data && data.items.length > 0) {
            data.type = GALLERIES_LOADED;
            data.language = state.app.language;
            dispatch(data);
        } else {
            dispatch(setNotFoundFlag(true));
        }

        dispatch(setLoadingFlag(false));
    }).catch(() => {
        dispatch(setErrorFlag(true));
        dispatch(setLoadingFlag(false));
    });
};


// WEBPACK FOOTER //
// ./src/js/reducers/galleries.js